import { api } from "./client";
import type { Pricing } from "./events";

export type OriginRow = {
  id: string;
  slug: string;
  display_name: string | null;
  created_at: string | null;
  event_count: number;
};

export type OriginListResponse = {
  origins: OriginRow[];
  page: number;
  page_size: number;
  total: number;
};

export type OriginListParams = {
  page: number;
  page_size?: number;
  q?: string;
};

export type OriginDetail = {
  id: string;
  slug: string;
  display_name: string | null;
  welcome_headline: string | null;
  welcome_body: string | null;
  button_text: string;
  logo_url: string | null;
  mobile_logo_url: string | null;
  created_at: string | null;
  updated_at: string | null;
  event_count: number;
  default_event_id: string | null;
  default_pricing: Pricing | null;
};

export type OriginPatch = Partial<{
  slug: string;
  display_name: string | null;
  welcome_headline: string | null;
  welcome_body: string | null;
  button_text: string;
  logo_url: string | null;
  mobile_logo_url: string | null;
  default_pricing: Pricing;
}>;

export type OriginCreate = {
  slug: string;
  display_name: string | null;
  welcome_headline: string | null;
  welcome_body: string | null;
  button_text: string;
  logo_url: string | null;
  mobile_logo_url: string | null;
};

export const OriginsApi = {
  list(params: OriginListParams) {
    return api
      .get<OriginListResponse>("/origins", {
        params: {
          page: params.page,
          page_size: params.page_size ?? 40,
          q: params.q || undefined,
        },
      })
      .then((r) => r.data);
  },
  get(id: string) {
    return api.get<OriginDetail>(`/origins/${id}`).then((r) => r.data);
  },
  create(body: OriginCreate) {
    return api.post<OriginDetail>("/origins", body).then((r) => r.data);
  },
  update(id: string, patch: OriginPatch) {
    return api.patch<OriginDetail>(`/origins/${id}`, patch).then((r) => r.data);
  },
  getLogoUploadUrl(contentType: string) {
    return api
      .post<{ uploadUrl: string; key: string; publicUrl: string; expiresIn: number }>(
        "/origins/logo/upload-url",
        { contentType },
      )
      .then((r) => r.data);
  },
  bulkDelete(ids: string[]) {
    return api
      .delete<{ deleted: string[]; refused: string[] }>("/origins", {
        data: { ids },
      })
      .then((r) => r.data);
  },
};
